import { render, staticRenderFns } from "./ViewEmployee.vue?vue&type=template&id=22aae663&"
import script from "./ViewEmployee.vue?vue&type=script&lang=js&"
export * from "./ViewEmployee.vue?vue&type=script&lang=js&"
import style0 from "./ViewEmployee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports